module.exports = __webpack_public_path__ + "img/sun-life-logo.778b098f.png";